// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"223":"commons","293":"component---src-pages-index-js","898":"component---src-pages-nase-prace-js","929":"component---src-pages-kontakt-js"}[chunkId] + "-" + {"223":"3a522fa99055e8ae08a3","293":"26b2ea6446c379ab14dd","898":"df6ad4a797a593b39e60","929":"9a0844bd2421fd3931fe"}[chunkId] + ".js";
};